import React from "react";

export const LazyReviewInducementScan = React.lazy(
    () =>
        import(
            /* webpackChunkName: "ReviewInducementScan" */ "./ReviewInducementScan"
        )
);
